import React from "react";
import data from "../../json/Typesettingkpo/Section2.json";

const Section2 = () => {
  return (
    <div className="w-full flex justify-center">
      <div className="2xl:container p-4 md:px-20 flex flex-col gap-16">
        {data.map((item, i) => (
          <div
            key={i}
            className={`flex min-h-[433px] flex-col gap-5 md:gap-0 md:flex-row md:even:flex-row-reverse imgjustify`}
          >
            <div className="w-full md:w-2/4 flex justify-left items-center imgdiv">
              <div className="w-full md:w-5/6 h-min flex items-center rounded-[32px] shadow-typesetting p-4">
                <img
                  className="object-fit w-full"
                  src={process.env.PUBLIC_URL + item.img}
                  alt={item.heading + "_img"}
                />
              </div>
            </div>
            <div className="w-full md:w-2/4 flex flex-col p:4 md:p-[34px] gap-4">
              <h1 className="text-24 md:text-28 lg:text-32">{item.heading}</h1>
              <p className="text-base md:text-18 text-approachblk ">
                {item.para}
              </p>
              <div className="flex flex-col gap-6">
                {item.points
                  ? item.points.map((pt, i) => (
                      <div key={i} className="flex gap-3">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/Herosection/rightarrow.svg"
                          }
                          alt="."
                        />
                        <p className="text-base md:text-18 font-medium text-approachblk">
                          {pt}
                        </p>
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Section2;
